import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { ValidatorForm } from "react-material-ui-form-validator";
import PasswordInput from "@View/components/passwordField/PasswordInput";
import ModalTittle from "@View/components/ModalTittle";
import ButtonSave from "@View/components/buttons/ButtonSave";
import Logo from "@View/components/svgComponents/Logo";
import Localization from "@View/components/Localization";
import Loader from "@View/components/loader/Loader";
import { Snackbar } from "@State/actions/actionCreators";
import { isValidPassword } from "../../security";
import getAPI from "@API/index";
import "@View/components/formInputs/inputs.css";

const box: any = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  background: "#FEFFFF",
  outline: "none",
  borderRadius: "9px",
  maxWidth: "360px",
  width: "100%",
  height: "auto",
  padding: " 20px 40px",
  boxSizing: "border-box",
};

const linkStyle: any = {
  textAlign: "center",
  color: "#6FA4F2",
  fontSize: "12px",
  lineHeight: "16px",
  fontWeight: 500,
};

const SetupPassword = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [form, setForm] = useState({
    password: "",
    confirmPassword: "",
  });

  const formRef = useRef<ValidatorForm | null>();

  const submitForm = () => {
    (async () => {
      if (formRef.current) {
        const isFormValid = await formRef.current.isFormValid(true);
        if (isFormValid) {
          const URLParams = new URLSearchParams(window.location.search);
          const email = URLParams.get("email");
          const token = URLParams.get("token");
          if (email && token) {
            await getAPI().request({
              method: "post",
              url: `/api/account/reset-password`,
              data: {
                email: email,
                password: form.password,
                confirmPassword: form.confirmPassword,
                token,
              },
              successText: t("PasswordSaved"),
            });
            setTimeout(() => {
              window.location.href = "/";
            }, 5000);
          } else {
            dispatch(Snackbar({ message: t("FormIncorrect"), open: true }));
          }
        } else {
          dispatch(Snackbar({ message: t("FormIncorrect"), open: true }));
        }
      }
    })();
  };

  useEffect(() => {
    ValidatorForm.addValidationRule("isPasswordMatch", (value) => {
      return form.password === value;
    });
    return () => {
      ValidatorForm.removeValidationRule("isPasswordMatch");
    };
  }, [form.password]);

  return (
    <>
      <Loader />
      <div style={box}>
        <ValidatorForm
          ref={(r) => (formRef.current = r)}
          onSubmit={() => submitForm()}
          instantValidate={true}
          autoComplete="off"
          style={{
            display: "flex",
            flexFlow: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
          }}
        >
          <div style={{ paddingTop: "30px" }}></div>
          <div style={{ position: "absolute", right: "5px", top: "0px" }}>
            <Localization />
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginBottom: "30px",
            }}
          >
            <Logo width="126" height="24" />
          </div>

          <ModalTittle children2={""}>SetupPassword</ModalTittle>

          {/* TextValidator renders its own wrapper div, which would shrink
              to fit inside the centered flex form — keep the field full width */}
          <div style={{ width: "100%" }}>
            <PasswordInput
              autoFocus
              className={"PassInput PassInput--helper"}
              variant={"standard"}
              margin={"none"}
              value={form.password}
              label={t("New password")}
              onChange={(value: string) => setForm({ ...form, password: value })}
            />
          </div>
          <div style={{ width: "100%" }}>
            <PasswordInput
              className={"PassInput PassInput--helper"}
              variant={"standard"}
              margin={"none"}
              value={form.confirmPassword}
              label={t("Confirm password")}
              customValidatorNames={["isPasswordMatch"]}
              onChange={(value: string) =>
                setForm({ ...form, confirmPassword: value })
              }
            />
          </div>
          <div style={{ width: "100%" }}>
            <ButtonSave
              marginTop={"10px"}
              marginBottom={"20px"}
              disabled={form.password ? !isValidPassword(form.password) : false}
            >
              buttons.Save
            </ButtonSave>
          </div>
          <Link style={{ textDecoration: "none" }} to={`/`}>
            <div style={linkStyle}>{t("SignIn")}</div>
          </Link>
        </ValidatorForm>
      </div>
    </>
  );
};

export default SetupPassword;
